import Suspense from '@/components/Suspense'
import { CustomRouteProps } from '@/types/router'
import {
  AnalyticsResidentDomain,
  AnalyticsResidentAccountActionTypes,
} from '@purepm/portals-ui'
import React from 'react'

const ProfileDetailsPage = React.lazy(
  () => import('./pages/ProfileDetailsPage'),
)
const PaymentMethod = React.lazy(() => import('./pages/PaymentMethods'))

const commonAnalyticsClickData = {
  domain: AnalyticsResidentDomain.ACCOUNT,
  feature: 'account_navigation',
}

const accountRoutes: CustomRouteProps[] = [
  {
    path: '/account/profile',
    name: 'Profile Details',
    description: 'Provide your full legal name and updated contact details',
    navigation: true,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={ProfileDetailsPage} />,
    analyticsClickData: {
      ...commonAnalyticsClickData,
      description: 'User clicked Profile Details section',
      action_type: AnalyticsResidentAccountActionTypes.PROFILE_DETAILS_ACCESSED,
      action_target: 'profile_details_card',
    },
  },
  {
    path: '/account/payment-method',
    name: 'Payment Method',
    description: 'Manage your payment sources for easy transactions',
    navigation: true,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={PaymentMethod} />,
    analyticsClickData: {
      ...commonAnalyticsClickData,
      description: 'User clicked Payment Options section',
      action_type: AnalyticsResidentAccountActionTypes.PAYMENT_OPTIONS_ACCESSED,
      action_target: 'payment_options_card',
    },
  },
]

export default accountRoutes
